import React from 'react';
import { getFormattedDateString } from '@css-xp/base';
import { Order } from '@css-xp/graphtypes/src/generated-types-new';
import { DATE_TIME_FORMAT } from '@atlassian/cssxp-typescommon';
import { NoData, SoldToCompanyName, InfoSection } from '@css-xp/ppc-common';

export const OrderInfoSection = ({ order, txaId }: { order: Order; txaId: string }) => {
  const orderDate = getFormattedDateString({ date: order?.created, format: DATE_TIME_FORMAT, showTime: true });
  const purchaseOrderNumber = order?.invoiceGroup?.purchaseOrder?.number;

  return (
    <InfoSection
      items={[
        { label: 'Ordered', value: orderDate ?? <NoData />, testId: 'order-created-timestamp-value' },
        {
          label: 'Customer',
          value: (
            <SoldToCompanyName
              txaId={txaId}
              companyName={order?.invoiceGroup?.shipToParty?.name}
              shouldRemoveLineClamp={true}
            />
          ),
        },
      ]}
    />
  );
};
